import { render, staticRenderFns } from "./ModalCompany.vue?vue&type=template&id=a859d5a4&"
import script from "./ModalCompany.vue?vue&type=script&lang=js&"
export * from "./ModalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports